import {
    condensedStateDesktopLogo,
    secondaryMenuDropdown,
    updateSubNavItemStyles,
    updatePrimaryNavDropdownPosition,
    updateSecondaryNavDropdownPosition,
    overflowDetector,
    firefoxaMoreItemsDropdown,
    enableDesktopClickDropdownsOnNoHover,
    enableNavigationV3HoverSync,
} from "../shared/desktop";
import {
    condensedMobileNavigationBar,
    expandMobileEditionMenu,
    expandMobileSidebarMenu,
    toggleMobileSubMenuLogo,
} from "../shared/mobile";

import { setEditionItemsWidth } from "../../furniture/_edition";

const runNavigationHandlers = () => {
    const navigation = document.querySelector("#mainNavigation");
    if (!navigation) {
        return;
    }

    expandMobileSidebarMenu();
    expandMobileEditionMenu();
    toggleMobileSubMenuLogo();
    condensedMobileNavigationBar();

    firefoxaMoreItemsDropdown();
    condensedStateDesktopLogo();
    secondaryMenuDropdown();
    updateSubNavItemStyles();
    updatePrimaryNavDropdownPosition();
    updateSecondaryNavDropdownPosition();
    overflowDetector();
    enableDesktopClickDropdownsOnNoHover();
    enableNavigationV3HoverSync();
};

if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", runNavigationHandlers);
} else {
    runNavigationHandlers();
}

window.addEventListener("resize", () => {
    setEditionItemsWidth();
});
